










import { Component, Watch, Vue } from 'vue-property-decorator';
import Checkbox from '@/components/form/Checkbox.vue';
import ExtLink from '@/components/ext/Link.vue';
import { RouteRules } from './types';

const RULES_AND_POLICY: string =
  'правилами сайта и политикой конфиденциональности';

@Component({
  components: {
    Checkbox,
    ExtLink,
  },
})
export default class Check extends Vue {
  check: boolean = false;
  policyURL: RouteRules = {
    text: RULES_AND_POLICY,
    to: { name: 'terms' },
    target: '_blank',
  };

  @Watch('check')
  isChecked(value: boolean) {
    this.$emit('checked', value);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/form/components/check/Check.vue